import type { DagNode, Registration, SeederInstance } from '../types/sales-demo.types';

export function deriveSeederName(address: string): string {
  const hostPart = address.split(':')[0];
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostPart)) {
    return hostPart;
  }
  return hostPart.split('.')[0];
}

export function deriveDatasetName(typeUrl: string): string {
  const parts = typeUrl.split('/');
  return parts[parts.length - 1];
}

/**
 * Groups all seeder instances by dataset TypeURL. Each TypeURL becomes one DAG
 * vertex containing every seeder that provides it; dependencies are unioned.
 */
export function buildDagNodes(registrations: Registration[]): DagNode[] {
  const nodesByType = new Map<string, DagNode>();

  for (const reg of registrations) {
    const specs = reg.datasetSpecs ?? [];

    for (const spec of specs) {
      const typeUrl = spec.typeUrl ?? '';
      if (!typeUrl) continue;

      const deps = (spec.dependencies ?? []).map((d) => d.typeUrl ?? '').filter(Boolean);
      const seeder: SeederInstance = {
        registrationId: reg.id ?? '',
        seederAddress: reg.address ?? '',
        seederName: deriveSeederName(reg.address ?? ''),
        status: reg.status ?? 'UNHEALTHY',
        heartbeatTime: reg.heartbeatTime ?? '',
        ephemeralId: reg.ephemeralId ?? '',
      };

      const existing = nodesByType.get(typeUrl);
      if (existing) {
        existing.seeders.push(seeder);
        for (const d of deps) {
          if (!existing.dependencies.includes(d)) existing.dependencies.push(d);
        }
      } else {
        nodesByType.set(typeUrl, { id: typeUrl, typeUrl, dependencies: [...deps], seeders: [seeder] });
      }
    }
  }

  return Array.from(nodesByType.values());
}
